'use client'

import { useQuery } from '@tanstack/react-query'
import { fetchStoreAddress } from '../services'

export const useStoreAddress = () => {
  return useQuery({
    queryKey: ['store-address'],
    queryFn: () => fetchStoreAddress(),
    staleTime: Infinity,
    gcTime: 1000 * 60 * 30,
    retry: 2,
    retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30000),
  })
}
